const players = [];

const player = function( node, settings = {} ) {
	const config = Object.assign( {
		videoWidth: '100%',
		videoHeight: '100%',
		stretching: 'responsive',
		showPosterWhenEnded: false,
	}, settings );

	config.success = function( media, node, instance ) {
		media.addEventListener( 'play', () => {
			instance.container.classList.add( 'gfi-mediaelement--active' );
			instance.container.classList.remove( 'gfi-mediaelement--paused' );
		} );
		media.addEventListener( 'ended', () => {
			instance.container.classList.remove( 'gfi-mediaelement--active' );
			instance.container.classList.remove( 'gfi-mediaelement--paused' );
		} );
		media.addEventListener( 'pause', () => {
			instance.container.classList.add( 'gfi-mediaelement--paused' );
		} );

		if ( typeof settings.success === 'function' ) {
			settings.success( media, node, instance );
		}
	}

	const instance = new MediaElementPlayer( node, config );

	// Check if the node src contains a time parameter
	const time = node.src.match(/t=(?:(\d+)m)?(?:(\d+)s)?/);

	if (time) {
		let seek = 0;
		const minutes = parseInt(time[1]);
		const seconds = parseInt(time[2]);
	
		if (!isNaN(minutes)) seek += minutes * 60;
		if (!isNaN(seconds)) seek += seconds;
	
		if (seek > 0) {
			instance.setCurrentTime(seek);
			instance.pause();
		}
	}

	players.push( instance );

	return instance;
}

document.addEventListener( 'DOMContentLoaded', function() {
	Array.from( document.querySelectorAll( '.gfi-mediaelement' ) ).forEach( video => player( video ) );
} );

export default {
	player,
	players,
}
